import React, { useState } from 'react';

import { KeyboardArrowDown } from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { shortcuts } from './shortcuts';
import ShortcutTable from './ShortcutTable';

type Props = {
    open: boolean;
    onClose: () => void;
};

/**
 * Modal dialog that explains whiteboard hotkeys and their functions.
 */
const HelpModal = React.memo((props: Props) => {
    const { t } = useTranslation(['whiteboard', 'common']);
    const [expandedIndex, setExpandedIndex] = useState<number>(0);

    const handleOnChange = (index, expanded: boolean) => {
        setExpandedIndex(expanded ? index : -1);
    };

    return (
        <Dialog open={props.open} maxWidth="sm" fullWidth={true} onClose={props.onClose}>
            <DialogTitle>{t('whiteboard:keyboardShortcuts')}</DialogTitle>
            <DialogContent>
                {shortcuts.map((shortcutList, shortcutIndex) => (
                    <Accordion
                        key={shortcutIndex}
                        expanded={expandedIndex === shortcutIndex}
                        onChange={(event, expanded) => handleOnChange(shortcutIndex, expanded)}
                    >
                        <AccordionSummary
                            expandIcon={<KeyboardArrowDown />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography variant="subtitle1">{t(shortcutList.name)}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ShortcutTable shortcutList={shortcutList} />
                        </AccordionDetails>
                    </Accordion>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="contained" color="primary">
                    {t('common:close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default HelpModal;
